<template>
  <div id="app">
    <!-- 其他页 -->
    <el-container v-if="$route.meta.keepAlive">
      <el-header style="height: 80px;">
        <keep-alive>
          <!-- 导航栏 -->
          <Navigation></Navigation>
        </keep-alive>
      </el-header>
      <el-container>
        <el-aside width="auto">
          <!-- 侧边栏 -->
          <keep-alive><left></left></keep-alive>
        </el-aside>
        <el-main>
          <!-- Body -->
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>

    <!-- 登录页 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue';
import left from '@/components/left.vue';
import '@/assets/style/icon.css';
import '@/assets/style/search.css';
import global from'@/utils/global'
export default {
  name: 'App',
  components: {
    Navigation,
    left
  },
  // mounted() {
  //   window.onload = ()=>{
  //     localStorage.setItem('path','')
  //     var token = sessionStorage.getItem('Authorization')
  //     this.$store.commit(token)
  //   }
  // }
};
</script>

<style>
/* html {
  background: #fff;
} */

html,
body,
#app,
.el-container {
  // width: 1000px;
  margin: 0px;
  padding: 0px;
  height: 100%;
  background: #fff;
}
.el-header {
  background-color: #4387cb;
  color: #333;
  line-height: 80px;
}
.el-menu {
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
.divBox {
  display: flex;
  flex-flow: row;
  align-items: center;
}
.box-card-search {
  border-radius: 20px;
  /* height: 148px; */
  margin: 0px 0px 30px ;
}
</style>



// WEBPACK FOOTER //
// src/App.vue